<template>
<li class="current">
    <a href="/courses/"><i class="fa fa-list-alt"></i> Kurse
        <span class="badge badge-new-bookings" data-toggle="tooltip" data-placement="right" title="Courses title here">4</span>
    </a>
    <div class="grid-container4">
        <ul>
            <li><a href="/courses/bookings/"><i class="fa fa-calendar-check-o"></i>Alle Buchungen</a></li>
            <li><a href="/courses/bookings/status/new/"><i class="fa fa-user-plus"></i> Unbestätigte Buchungen</a></li>
            <li><a href="/courses/bookings/status/waitlist/"><i class="fa fa-list-ol"></i> Warteliste</a></li>
        </ul>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
